import React, { useState, Component, Fragment } from 'react'
import { Form } from 'informed'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { Text, Checkbox, Select, Number as NumberInput } from 'components/forms'
import Divider from 'components/Divider'
import Button from 'components/Button'
import { getProduct_Ingrs, listIngredients } from '../../../gql/query'
import getNameOfGqlQuery from 'helpers/getNameOfGqlQuery'
import { Add } from 'media/icons'
import styles from '../ingredients.module.scss'

const IngredientDetails = ({ ingredientGroup, mutateProduct, mutateIngr, mutationIngrName, ingrData, productIngrs, closeForm, product }) => {
	const [isAddingNewIngr, setIsAddingNewIngr] = useState(false)
	const [t] = useTranslation()

	const onCloseForm = () => {
		setIsAddingNewIngr(false)
		closeForm()
	}
	const isMutationUpdate = ingrData.productIngrId
	const showAdditionalFields = isAddingNewIngr && ingrData.id < 0

	return(
		<div className={classNames('theme-light', styles['form-container'])}>
			<p className={styles.title}>
				{t(`product_section.strings.${ingredientGroup === 'nutrients' ? 'nutrients' : 'allergens'}`)} {t('product_section.strings.add')}
			</p>
			<Divider height={34} visible inverted className={styles.divider} />
			<Form
				initialValues={ingrData}
				onSubmit={({ ingredient, productId, ...productIngr }) => {
					const { id, ingredientId, amount, contains } = productIngr
					const prodIngrFields = {
						...ingredientId && { ingredientId },
						...amount && { amount },
						contains: !!contains
					}
					if(!isAddingNewIngr) {
						if(id) {
							prodIngrFields.id = id
						}
						/*const clonedItem = productIngrs[0]
						const ingredients = id > 0 ?
							productIngrs.map(item => Number(item.id) === Number(id) ? ({ ...item, ...productIngr, mod_ver: -1, ingredient: { ...item.ingredient, id: ingredientId } }) : item)
							: [...productIngrs, ...clonedItem ? [{ ...clonedItem, ...prodIngrFields, id: id || -1, ingredient: { ...clonedItem.ingredient, id: ingredientId,  } }] : []]
						const optimisticResponse = {
							cashAssist: {
								updateProduct: {
									...product,
									ingredients: ingredients,
									__typename: 'Product'
								},
								__typename: 'CA_Mutation'
							},
							__typename: 'Mutation'
						}
						mutateProduct({ ingredients: [prodIngrFields] }, { optimisticResponse })*/
						mutateProduct({ ingredients: [prodIngrFields] })
					} else {
						mutateIngr({
							variables: {
								required: { productId },
								fields: {
									...prodIngrFields,
									ingredient
								}
							},
							update: (cache, { data: { [mutationIngrName]: dataFields } }) => {
								// Update cache of query 'listIngredients' if only the new Ingredient (not just ProductIngredient) was added
								if(!ingredientId) {
									const queryName = getNameOfGqlQuery(listIngredients)
									const queryVars = { type: ingredientGroup }
									const { [queryName]: ingrs } = cache.readQuery({ query: listIngredients, variables: queryVars })
									cache.writeQuery({
										query: listIngredients,
										variables: queryVars,
										data: { [queryName]: [...ingrs, dataFields.ingredient] }
									})
								}
								// Update cache of Product ingredients
								const prodQueryName = getNameOfGqlQuery(getProduct_Ingrs)
								const { [prodQueryName]: cachedProduct } = cache.readQuery({ query: getProduct_Ingrs, variables: { id: productId } })
								const { ingredients: cachedProdIngrs } = cachedProduct
								const { ingredient: { code, units, ...restIngrFields } } = dataFields
								let wasProdIngrUpdated = false
								const newProdIngr = { ...dataFields, ingredient: { ...restIngrFields } }
								const newIgrs = cachedProdIngrs.map(item => {
									// Replace old value or optimisticResponse value(with id '-1') if it exists
									if(Number(item.id) === Number(id) || Number(item.ingredientId) === -1) {
										wasProdIngrUpdated = true
										return newProdIngr
									}
									return item
								})
								if(!wasProdIngrUpdated) {
									newIgrs.push(newProdIngr)
								}
								cache.writeQuery({
									query: getProduct_Ingrs,
									variables: { id: productId },
									data: { [prodQueryName]: { ...cachedProduct, ingredients: [...newIgrs] } }
								})
							},
							optimisticResponse: {
								__typename: 'Mutation',
								[mutationIngrName]: {
									__typename: 'ProductIngredient',
									id: id || -1,
									ingredientId: ingredientId || -1,
									productId,
									amount,
									contains,
									mod_ver: -1,
									ingredient: {
										id: ingredientId || -1,
										__typename: 'Ingredient',
										...isAddingNewIngr && { ...ingredient, id: -1 }
									}
								}
							}
						})
					}
					onCloseForm()
				}}
			>
				{({ formApi }) => (
					<Fragment>
						<Select disabled={true} field='ingredient.group' label={t('product_section.strings.group')} inverted
							options={[
								{ label: t('product_section.strings.nutrients'), value: 'nutrients' },
								{ label: `${t('product_section.strings.nutrients') + 'EU'}`, value: 'allergens_EU' }
							]}
						/>
						<div className={styles['add-container']}>
							{showAdditionalFields ?
								<Text field='ingredient.name' label={t('product_section.fields.name')} /> :
								<Select
									field='ingredientId'
									label={t('product_section.fields.name')}
									validate={val => {
										// Don't validate field if it's has not changed
										if(Number(val) === Number(ingrData.ingredientId)) {
											return
										}
										const isAlreadyInProduct = productIngrs.find(({ ingredientId, contains }) => ingredientGroup === 'allergens_EU' ?
											Number(ingredientId) === Number(val) && contains
											:
											Number(ingredientId) === Number(val)
										)
										if(isAlreadyInProduct) {
											return t('product_section.strings.ingr_in_product')
										}
									}}
									labelField='name'
									remoteOptions={{ query: listIngredients, variables: { type: ingredientGroup } }}
									validateOnChange
									valueField='id' />
							}
							<div>
								{ingrData.id < 0 &&
									<div className={styles['add-btn']} onClick={e => setIsAddingNewIngr(true)}>
										<Add />
									</div>
								}
							</div>
						</div>
						{ingredientGroup === 'nutrients' && <NumberInput field='amount' label={t('common.fields.quantity')} precision={3} step={0.001} inline shrink/>}
						{ingredientGroup === 'allergens_EU' &&
							<Checkbox field='contains' label={t('product_section.fields.contains')} disabled />
						}
						{showAdditionalFields && (
							<Fragment>
								<Text field='ingredient.code' label={t('product_section.fields.number')} inline shrink />
								<Select field='ingredient.units' label={t('product_section.fields.units')} inline shrink
									options={[
										{ label: 'µ/100g', value: 'µ/100g' },
										{ label: 'mg/100g', value: 'mg/100g' },
										{ label: 'KJ', value: 'KJ' },
										{ label: 'kcal', value: 'kcal' },
										{ label: 'g/100g', value: 'g/100g' }
									]}
								/>
								<Text field='ingredient.keyword' label={t('product_section.fields.keyword')} inline shrink/>
							</Fragment>
						)}
						<Text field='id' hidden />
						<div>
							<Button
								shrink
								type='submit'
								status={((formApi.getValue('ingredientId') > 0 || formApi.getValue('ingredient.name')) && formApi.getValue('ingredient.group')) ? 'primary' : 'inactive'}
								text={isMutationUpdate ? t('common.buttons.save') : t('common.buttons.add')} />
							<Button shrink text={t('common.buttons.cancel')} status='cancelation' onClick={e => onCloseForm()} />
						</div>
					</Fragment>
				)}
			</Form>
		</div>
	)
}

export default IngredientDetails
